import { LocalizedText } from '@common/models';

export class UcCode
{

    constructor (public useCaseTypeId: number, public useCaseCode: string, public useCase: LocalizedText)
    {
    }
}
